import { useSingleChargePoint } from "../../../hooks/useChargePoint";
import useConnectors, {
  useSingleConnector,
} from "../../../hooks/useConnectors";

import { LoaderSreen } from "../../../../../common/components/molecule/Loader/Loader";

import ErrorScreenApp from "../../../../errorHandler/components/ErrorScreenApp/ErrorScreenApp";
import ConnectorListView, {
  ConnectorItem,
} from "./ConnectorListView/ConnectorListView";
import SingleHardware from "../../../../hardwares/components/SingleHardware";
import { ButtonWithComfirmationModal } from "../../../../../common/components/organisme/ModalWindow/ModalWindow";
import { useAuth } from "../../../../auth/hooks";
import { userRoles } from "../../../../user/types/user.types";
import useNavigationApp from "../../../../../navigation/useNavigationApp";
import { JWayIconConnectorConverter } from "../../../utils/iconConverterConnector";

export default function ConnectorListPresenter({
  chargePointId,
  stationId,
}: {
  chargePointId?: string;
  stationId?: string;
}) {
  const { chargePointIdFound, stationIdFound } = useSingleChargePoint({
    chargePointId,
    stationId,
  });
  const {
    getAllConnectorsQuery: { data, isLoading, error },
  } = useConnectors({ chargePointId: chargePointIdFound });

  const navigate = useNavigationApp();
 
  if (isLoading) {
    return <LoaderSreen heigth={"100px"} />;
  }

  if (error) {
    return <ErrorScreenApp axiosError={error} />;
  }

  const listFormated: ConnectorItem[] | undefined = data?.data?.map(
    (connector) => {
      return {
        icon: () => <> {JWayIconConnectorConverter(connector.b_connector_type, 15, "#00000050", {marginTop: 7})}</>,
        id: connector.b_connector_id,
        name: "N/A",
        hardwareId: connector.b_connector_hardware_id,
        tag: String(connector.b_connector_tag_id),
        type: connector.b_connector_type,
        currency: connector.b_connector_price_currency,
        pricePerKwh: connector.b_connector_price_per_kwh,
        onClick: () => { navigate.goToSingleConnector(stationIdFound, chargePointIdFound as string, connector.b_connector_id, {keepURL: true}) },
        ActionBtnRender: () => (
          <ActionBtn
            idChargePoint={chargePointIdFound || undefined}
            connectorId={connector.b_connector_id}
          />
        ),
        hardwareIDRender: () => (
          <SingleHardware.DevUID
            hardwareId={connector.b_connector_hardware_id}
          />
        ),
      };
    }
  );

  return <ConnectorListView content={listFormated || []} />;
}

const ActionBtn = ({
  idChargePoint,
  connectorId,
}: {
  idChargePoint?: string;
  connectorId?: string;
}) => {
  const {
    deleteSingleConnectorQuery: deleteQ,
    getSingleConnectorQuery: { data },
  } = useSingleConnector({
    chargePoint: idChargePoint,
    connectorId: connectorId,
  });

  const { userRole } = useAuth();
  if (!userRole || userRole < userRoles.ADMIN) {
    return <></>;
  }

  return (
    <div style={{ display: "flex", justifyContent: "flex-end" }}>
      <ButtonWithComfirmationModal
        titleModal="Suppression"
        desc={
          "Voulez-vous vraiment supprimer le connector " +
          data?.b_connector_tag_id +
          "?"
        }
        height={"10px"}
        fontSize={"0.8rem"}
        borderRaduis={"10px"}
        variant={"outlined"}
        isLoading={deleteQ.isLoading}
        onClick={() => {
          deleteQ.mutate({});
        }}
        label="Supprimer"
        borderColor="#7C030370"
        fontColorHex="#7C030370"
        bgColorHex="transparent"
      />
    </div>
  );
};
